import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {TABLE_ROW_HEIGHT} from '../../util/constants';

export const RunsHiddenByFiltersBanner = () => {
  return (
    <TailwindContents>
      <div
        style={{height: TABLE_ROW_HEIGHT}}
        className="flex items-center justify-center overflow-hidden bg-wb-surface px-3 text-center text-sm italic leading-5 text-wb-text-tertiary border-y border-wb-divider">
        <span
          className="min-w-0 max-w-full truncate"
          title="Additional search results are hidden by active filters">
          Additional search results are hidden by active filters
        </span>
      </div>
    </TailwindContents>
  );
};
